import { EntityField } from "src/app/create/models/entity.model";
import { SurveyModel } from "src/app/dashboard/dashboard.model";

export class EntityMaster{
    entityID : string;
    entityName: string;
    entityDescription: string;
    isDeleted: boolean;
    entityStatus :string;
    entityFields :EntityField[];  
    isLookUp: boolean;
    surveyModel : SurveyModel;  
}